import { render, staticRenderFns } from "./m-edit-styled-text.vue?vue&type=template&id=113c0570&scoped=true&"
import script from "./m-edit-styled-text.vue?vue&type=script&lang=js&"
export * from "./m-edit-styled-text.vue?vue&type=script&lang=js&"
import style0 from "./m-edit-styled-text.vue?vue&type=style&index=0&id=113c0570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113c0570",
  null
  
)

export default component.exports